import truckload from './assets/truckload.avif'
import cloudLogo from './assets/GntB5.jpg'
import TransportIcon from './components/icons/TransportIcon'
import InvestmentIcon from './components/icons/InvestmentIcon'
import TechnologyIcon from './components/icons/TechnologyIcon'

const contentFr = {
    brand: 'Groupe Ouambo',
    tagline: 'Holding Technologie et Digitalisation',
    nav: {
      home: 'Accueil',
      about: 'A propos',
      services: 'Services',
      technology: 'Technologie et IA',
      platforms: 'Plateformes digitales',
      energy: 'Énergie',
      transport: 'Logistique & corridor',
      investment: 'Investissement / partenariats',
      contact: 'Contact',
      careers: 'Carrières',
      cta: 'Demarrer un projet'
    },
    hero: {
      eyebrow: 'Technologie et digitalisation',
      title: 'Technologie et digitalisation',
      subtitle:
        'Des plateformes assistées par l’IA pour l’apprentissage, le commerce et les opérations — conçues pour le terrain, déployées localement.',
      primary: 'Demarrer un projet',
      secondary: 'Rencontrer l equipe'
    },
    stats: [
      { value: '2023', label: 'Holding fondée' },
      { value: '3', label: 'Plateformes phares' },
      { value: 'CM→RCA', label: 'Déploiement terrain' }
    ],
    highlights: [
      { label: 'OnboardLearning.org — EdTech / LMS bilingue', href: 'https://onboardlearning.org' },
      { label: 'Galababa.com — Marketplace de Bangui', href: 'https://galababa.com' },
      { label: 'KesseDesk — chat en direct et noms de domaine', href: 'https://www.kessedesk.com' },
      { label: 'IA pratique et digitalisation des institutions' }
    ],
    about: {
      title: 'Qui nous sommes',
      lead:
        'Groupe Ouambo est un groupe de technologie et de digitalisation. Fondé en 2023 comme holding d’investissement et de technologie, nous concevons et opérons des plateformes numériques — dont OnboardLearning, Galababa et KesseDesk — accompagnons les institutions dans l’adoption d’outils modernes et d’une IA pratique, et maintenons un réseau de corridor pour que ces produits rejoignent les utilisateurs sur le terrain.',
      readMore: 'En savoir plus',
      paragraphs: [
        'Nous créons de la valeur à long terme en livrant des produits utilisés — plateformes d’apprentissage, marketplaces et programmes de digitalisation — avec un déploiement terrain du Cameroun à la RCA.',
        'La logistique et le corridor restent un pilier opérationnel qui facilite le commerce et le dernier kilomètre, pour que les produits numériques et le commerce circulent dans la région.',
        'En parallèle, nous investissons dans des technologies qui améliorent la productivité, modernisent les processus et accélèrent une transformation digitale responsable.',
        'Groupe Ouambo opère avec une approche d’investissement rigoureuse, des standards de gouvernance solides et une vision à long terme.',
        'Nous recherchons des partenariats avec les institutions publiques, les entreprises privées et les acteurs internationaux pour une croissance durable et une création de valeur partagée.'
      ],
      vision: {
        title: 'Notre vision',
        body:
          'Devenir le groupe de technologie et de digitalisation de confiance — reconnu pour des plateformes qui fonctionnent sur le terrain et des partenariats durables.'
      },
      values: {
        title: 'Nos valeurs',
        items: [
          { title: 'Integrite', body: 'Transparence et gouvernance ethique dans toutes nos operations' },
          { title: 'Innovation', body: 'IA pratique et outils digitaux adaptés aux réalités locales' },
          { title: 'Excellence', body: 'Engagement envers la qualite, la performance, et l amelioration continue' },
          { title: 'Partenariat', body: 'Construire des relations durables et creatrices de valeur' },
          { title: 'Durabilite', body: 'Investir avec une vision economique et sociale de long terme' }
        ]
      },
      cards: [
        {
          title: 'Technologie et IA',
          body: 'Plateformes et IA pratique pour l’apprentissage, le commerce et les opérations.'
        },
        {
          title: 'Plateformes digitales',
          body: 'OnboardLearning, Galababa et KesseDesk — nos produits phares.'
        },
        {
          title: 'Pilier logistique',
          body: 'Réseau de corridor pour que le digital rejoigne les utilisateurs réels.'
        }
      ]
    },
    businesses: {
      title: 'Nos piliers',
      intro:
        'La technologie et la digitalisation en tête. La logistique reste le backbone. L’investissement alimente les partenariats.',
      readMore: 'En savoir plus',
      items: [
        {
          title: 'Technologie et IA',
          body:
            'Digitalisation pratique et IA responsable — plateformes, outils et services pour les institutions et les entreprises.',
          iconSvg: <TechnologyIcon />,
          iconAlt: 'Technologie et IA',
          route: '/technology'
        },
        {
          title: 'Plateformes digitales',
          body:
            'Produits phares : OnboardLearning.org (LMS bilingue), Galababa.com (marketplace de Bangui) et KesseDesk — chat en direct et noms de domaine pour les entreprises : ajoutez le support client à votre site en quelques minutes.',
          iconEmoji: '💻',
          iconAlt: 'Plateformes digitales',
          route: '/technology#platforms',
          products: [
            { label: 'OnboardLearning.org', href: 'https://onboardlearning.org' },
            { label: 'Galababa.com', href: 'https://galababa.com' },
            { label: 'KesseDesk', href: 'https://www.kessedesk.com' }
          ]
        },
        {
          title: 'Énergie',
          body:
            'Nous explorons des partenariats autour de l’accès à l’énergie pour soutenir la digitalisation, les opérations et les communautés — par des études, des partenaires et un déploiement progressif.',
          iconEmoji: '⚡',
          iconAlt: 'Énergie',
          route: '/technology#energy'
        },
        {
          title: 'Logistique & corridor',
          body:
            'Réseau de corridor et opérations de transit — le pilier opérationnel qui aide les produits numériques et le commerce à rejoindre les utilisateurs, du Cameroun à la RCA.',
          iconSvg: <TransportIcon />,
          iconAlt: 'Logistique et corridor',
          route: '/transport'
        },
        {
          title: 'Investissement / partenariats',
          body: 'Capital stratégique et partenariats pour renforcer la digitalisation, les infrastructures et la croissance régionale.',
          iconSvg: <InvestmentIcon />,
          iconAlt: 'Investissement et partenariats',
          route: '/investment'
        }
      ]
    },
    pages: {
      transport: {
        title: 'Logistique et corridor',
        lead:
          'Nous opérons des capacités logistiques et de corridor qui connectent le commerce régional — le backbone qui soutient le déploiement digital sur le terrain.',
        image: truckload,
        imageAlt: 'Logistique de corridor',
        cta: 'Commencer a expedier',
        ctaSecondary: 'Contact pour le passage en douane',
        points: [
          'Operations de transit et logistique de corridors',
          "Facilitation de l'import-export et conformite",
          'Visibilite de la chaine logistique et efficacite'
        ],
        longSections: []
      },
      investment: {
        title: 'Investissement et partenariats',
        lead:
          'Nous déployons du capital et construisons des partenariats là où ils créent de la valeur digitale et économique sur le long terme.',
        points: [
          'Partenariats digitalisation et plateformes',
          'Infrastructures et facilitation du commerce régional',
          "Structures d'investissement axées sur la gouvernance"
        ]
      },
      technology: {
        title: 'Technologie et IA',
        lead:
          'Digitalisation pratique et IA responsable — plateformes pour l’apprentissage, le commerce et les opérations.',
        image: cloudLogo,
        imageAlt: 'Plateformes technologiques',
        cta: 'Demarrer un nouveau projet',
        ctaRoute: '/contact',
        points: [
          'Plateformes assistées par l’IA avec supervision humaine',
          'Plateformes digitales pour les économies modernes',
          'Déploiement terrain du Cameroun à la RCA'
        ],
        longSections: [
          {
            title: 'Plateformes digitales',
            body:
              'OnboardLearning.org — LMS bilingue pour l’éducation et les compétences. Galababa.com — marketplace de Bangui pour le commerce local. KesseDesk — chat en direct et noms de domaine pour les entreprises : ajoutez le support client à votre site en quelques minutes. Conçus pour les réalités locales.'
          },
          {
            title: 'Equipements IT et deploiement',
            body:
              'Nous deployons des equipements IT adaptes aux besoins operationnels modernes - serveurs, equipements reseau, materiel informatique, et infrastructure de support.'
          },
          {
            title: 'Connectivite et ecosystemes numeriques',
            body:
              'Nous facilitons la connectivite internet via des reseaux performants, des solutions du dernier kilometre, et des systemes de communication numerique — pour des ecosystemes numeriques resilients.'
          }
        ]
      }
    },
    equipment: {
      title: 'Materiel',
      lead: 'Des equipements IT fiables pour des operations modernes et evolutives.',
      linkLabel: 'Voir les details',
      backLabel: 'Retour au materiel',
      notFound: "Cet equipement n'est pas disponible.",
      items: [
        {
          slug: 'cloud-server-bundle',
          name: 'Pack serveurs cloud',
          price: '2 500 $',
          description: 'Puissance de calcul elevee pour le cloud et les charges critiques.'
        },
        {
          slug: 'enterprise-router',
          name: 'Routeur entreprise',
          price: '1 200 $',
          description: 'Routage securise et evolutif pour les sites multiples.'
        },
        {
          slug: 'data-storage-array',
          name: 'Baie de stockage',
          price: '3 800 $',
          description: 'Stockage resilient pour les donnees et sauvegardes.'
        },
        {
          slug: 'network-switch-48-port',
          name: 'Switch reseau 48 ports',
          price: '950 $',
          description: 'Commutation haut debit pour campus et data centers.'
        },
        {
          slug: 'security-firewall-appliance',
          name: 'Pare-feu securite',
          price: '1 600 $',
          description: 'Protection avancee avec supervision et controle des politiques.'
        }
      ]
    },
    contact: {
      title: 'Contact',
      lead: 'Parlez nous de vos objectifs. Reponse sous 48 heures.',
      form: {
        name: 'Nom',
        email: 'Email',
        message: 'Message',
        submit: 'Envoyer le message',
        heading: 'Contactez-nous',
        success: 'Message envoye. Nous vous recontacterons bientot.',
        error: "Une erreur s'est produite. Veuillez reessayer."
      },
      details: [
        { title: 'Location', body: 'USA 7502 Diplomat Dr ste 101, Unit B, Manassas VA 20109' },
        { title: 'Siege Social', body: 'Place de la Republique' },
        { title: 'Tel', body: '+237674687668 / +23672795479' },
        { title: 'Zone Africa', body: 'Central African Republic | Email: mp@groupeouambo.com' },
        { title: 'Cameroon', body: 'Yaounde | Tel: +23776083761 | Email: dg@groupeouambo.com' },
        { title: 'Zone USA', body: 'Rodrigue OUAMBO' },
        { title: 'USA Contact', body: '7502 Diplomat Dr, Manassas VA 20109 | Tel: +17038641447 | Email: rod@groupeouambo.com' },
        { title: 'Zone Europe', body: 'Villeurbanne' },
        { title: 'Europe Contact', body: 'Tel: +33651677745 | Email: info@groupeouambo.com' }
      ]
    },
    careers: {
      heroEyebrow: 'Rejoignez notre equipe',
      heroTitle: 'Carrieres chez Groupe Ouambo',
      heroSub: "Nous construisons la prochaine generation de plateformes digitales et de technologies. Grandissez avec nous.",
      openPositions: 'Postes ouverts',
      applyNow: 'Postuler',
      myApplications: 'Mes candidatures',
      signInRegister: 'Connexion / Inscription',
      loadingPositions: 'Chargement des postes...',
      noPositionsTitle: 'Aucun poste ouvert pour le moment',
      noPositionsBody: 'Revenez bientot ou envoyez une candidature spontanee.',
      sendGeneral: 'Candidature spontanee',
      signInToApply: 'Connectez-vous pour postuler',
      description: 'Description',
      requirements: 'Exigences',
      applyForPosition: 'Postuler a ce poste',
      generalApplication: 'Candidature spontanee',
      applyPrefix: 'Postuler -',
      needAccount: 'Un compte est necessaire pour postuler. Connectez-vous ou creez un compte gratuit pour envoyer votre candidature et suivre son statut.',
      signInCreate: 'Connexion / Creer un compte',
      applicationSubmitted: 'Candidature envoyee ! Une confirmation a ete envoyee a',
      willBeInTouch: 'Nous vous recontacterons bientot.',
      applyingAs: 'Candidature en tant que',
      selectPosition: 'Choisir un poste (optionnel)',
      generalSpontaneous: 'Generale / Spontanee',
      coverLetter: 'Lettre de motivation',
      optional: '(optionnel)',
      coverPlaceholder: 'Dites-nous pourquoi vous souhaitez rejoindre Groupe Ouambo...',
      resume: 'CV',
      resumeHint: '(PDF, DOC ou DOCX - optionnel)',
      submitting: 'Envoi...',
      submitApplication: 'Envoyer la candidature',
      clear: 'Effacer',
      applicantAccount: 'Compte candidat',
      authSub: 'Connectez-vous ou creez un compte gratuit pour postuler et suivre vos candidatures.',
      signIn: 'Connexion',
      createAccount: 'Creer un compte',
      fullName: 'Nom complet',
      namePlaceholder: 'Votre nom',
      emailAddress: 'Adresse e-mail',
      password: 'Mot de passe',
      pleaseWait: 'Veuillez patienter...',
      signOut: 'Deconnexion',
      submitNew: '+ Nouvelle candidature',
      loading: 'Chargement...',
      noAppsTitle: 'Aucune candidature pour le moment',
      noAppsBody: 'Parcourez les postes ouverts et envoyez votre premiere candidature.',
      applied: 'Deposee le',
      noteFromHr: 'Note RH',
      pleaseSignInApps: 'Veuillez vous connecter pour voir vos candidatures.',
      statusPending: 'En attente',
      statusReviewing: 'En examen',
      statusAccepted: 'Acceptee',
      statusRejected: 'Refusee'
    },
    footer: 'Groupe Ouambo'
  }

export default contentFr
